import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";
import IconLoader from "@/features/Common/components/IconLoader";

export interface HealthHistoryFlyUpModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdateBmi: () => void;
  onUpdateClinicalHistory: () => void;
}

export default function HealthHistoryFlyUpModal({
  isOpen,
  onClose,
  onUpdateBmi,
  onUpdateClinicalHistory,
}: HealthHistoryFlyUpModalProps) {
  const { t } = useTranslation();

  const handleUpdateBmi = () => {
    onClose();
    onUpdateBmi();
  };

  const handleUpdateClinicalHistory = () => {
    onClose();
    onUpdateClinicalHistory();
  };

  return (
    <DefentSheet
      expanded={isOpen}
      onClose={onClose}
      onExpandedChange={(expanded) => {
        if (!expanded) {
          onClose();
        }
      }}
    >
      <Stack spacing={4} alignItems="center" textAlign="center" px={2} py={4}>
        <IconLoader
          icon="HealthHistoryIcon"
          color="primary"
          sx={{ fontSize: 70 }}
        />

        <Stack spacing={2}>
          <Typography variant="h3" fontWeight={700} component="h2">
            {t("HealthHistory.flyUpModal.title")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("HealthHistory.flyUpModal.description")}
          </Typography>
        </Stack>

        <Stack width="100%" spacing={1.5}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleUpdateBmi}
          >
            {t("HealthHistory.flyUpModal.updateBmi")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleUpdateClinicalHistory}
          >
            {t("HealthHistory.flyUpModal.updateClinicalHistory")}
          </Button>
        </Stack>
      </Stack>
    </DefentSheet>
  );
}
